@for (step of steps; track step; let index = $index) {
  @if (index < currentStepIndex) {
    <span class="dot done"></span>
  }
  @if (index === currentStepIndex) {
    <p class="step-text">{{ 'stepper_step' | locale }} {{ index + 1 }}</p>
    <span class="rectangle"></span>
  }
  @if (index > currentStepIndex) {
    <span class="dot"></span>
  }
}
